<template>
  <div>
    <div class="bread-crumbs-box">
      <Breadcrumb separator="»" class="bread-crumbs container">
        <Breadcrumb-item class="breadcrumb-item" to="/">首页</Breadcrumb-item>
        <Breadcrumb-item class="breadcrumb-item-last">{{aboutInfo.title}}</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="container">
      <div class="aboutwe-view">
        <h2>{{aboutInfo.title}}</h2>
        <div class="aboutwe-box"></div>
      </div>
      <div class="aboutwe-view-one" v-html="aboutInfo.intro"></div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { article } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      aboutInfo: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      article.getAgencyIntro(this.siteConfig.agencyId).then((res) => {
        if (res.status === 1) {
          this.aboutInfo = res.data;
          this.setMetaData(this.aboutInfo.title);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bread-crumbs-box {
  background: #fff;
  margin-bottom: 32px;
  .bread-crumbs {
    height: 48px;
    line-height: 48px;
    background: #fff;
    .breadcrumb-item {
      color: #0e90d2;
      font-size: 15px;
    }
    .breadcrumb-item-last {
      color: #999;
      font-size: 15px;
    }
  }
}
.aboutwe-view {
  width: 1200px;
  margin: 0 auto;
  color: #1eadfc;
  border-bottom: 1px solid #1eadfc;
}
.aboutwe-box {
  width: 100px;
  height: 2px;
  background: #1eadfc;
  margin-left: 0;
}
.aboutwe-view-one {
  width: 1200px;
  min-height: 320px;
  margin: 24px auto 24px auto;
  background: white;
  padding: 20px;
  /deep/img {
    display: inline-block;
  }
}
</style>